import React from 'react'
import SuspenseLoader from 'modules/App/SuspenseLoader'

const LeadDetailV2 = React.lazy(() => import(/* webpackChunkName: "lead.details.v2" */ 'modules/Leads/LeadDetailV2'))

export default function LeadDetailsWrapper() {
  return (
    <SuspenseLoader>
      <LeadDetailV2 />
    </SuspenseLoader>
  )
}
